import bg from '../assets/bg.png';
import G from '../assets/G.png';
import menu from '../assets/menu.png';
import spoon from '../assets/spoon.png';
import welcome from '../assets/welcome.png';
import laurels from '../assets/laurels.png';
import awards from '../assets/awards.png';
import gericht from '../assets/gericht.png';
// eslint-disable-next-line
export default {
  bg,
  G,
  menu,
  spoon,
  welcome,
  laurels,
  gericht,
  awards,
};
